import { TabbedContentEntry, TabbedContentSection } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'

import { createTabbedContentEntry } from '../../StoryblokTabbedContentEntry/__mocks__/tabbedContentEntry'

/**
 * Creates a mock TabbedContentSection
 * @param overrides - Partial fields to override defaults
 * @returns Complete TabbedContentSection mock
 */
export function createTabbedContentSection(
  overrides: Partial<TabbedContentSection> = {}
): TabbedContentSection {
  return {
    _uid: '0df94950-1246-4af4-88e0-161421e79088',
    lead: 'Cupidatat consequat enim adipisicing laborum et.',
    headline: 'Tabbed Content Section',
    component: 'tabbed-content-section',
    entries: [
      createTabbedContentEntry({
        _uid: 'f320e324-83c4-4e23-94f3-1eefb8e7c410',
        image: createStoryblokAsset({
          id: 8908003,
          filename:
            'https://a.storyblok.com/f/228071/1920x1080/a17bd8776b/development.jpeg',
          src: 'https://a.storyblok.com/f/228071/1920x1080/a17bd8776b/development.jpeg',
          width: 1920,
          height: 1080,
          aspect_ratio: 1.78,
          content_type: 'image/jpeg',
          updated_at: '2024-01-01T00:00:00.000Z',
        }),
        description:
          'Culpa amet qui consectetur dolor in fugiat ea et nulla ea cillum laborum sint.',
      }),
      createTabbedContentEntry({
        _uid: '8685e05a-12f6-4df9-94a1-0cdfa64045fd',
        image: createStoryblokAsset({
          id: 1,
          alt: 'null',
          focus: 'null',
          title: 'null',
          source: 'null',
          filename: '',
          copyright: 'null',
          updated_at: '2024-01-01T00:00:00.000Z',
        }),
      }),
      createTabbedContentEntry({
        _uid: 'a5ed2d45-2310-451d-a8bb-2b2d1c5b0af3',
        image: createStoryblokAsset({
          id: 12,
          alt: 'null',
          focus: 'null',
          title: 'null',
          source: 'null',
          filename: '',
          copyright: 'null',
          updated_at: '2024-01-01T00:00:00.000Z',
        }),
        description:
          'Proident incididunt commodo aliquip irure ex enim mollit deserunt sunt.',
      }),
    ],
    _editable:
      '<!--#storyblok#{"name": "tabbed-content-section", "space": "228071", "uid": "0df94950-1246-4af4-88e0-161421e79088", "id": "300939517"}-->',
    ...overrides,
  }
}
